if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();

        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }

      get cookieName() {
        return 'concept:newsletter-popup';
      }

      get submited() {
        return this.querySelector('.alert') !== null;
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.submited) {
          this.load(1);
          return;
        }

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      load(delay) {
        if (Shopify.designMode) return;

        setTimeout(() => this.showWhenFree(), delay * 1000);
      }

      // 30/10 (conversation rapidité, vu en test : la fenêtre « serviette offerte » s'ouvrait par-dessus le panier
      // pendant que la cliente changeait ses quantités, et bloquait ses clics). Panier ouvert ou autre fenêtre ouverte :
      // on attend qu'il soit refermé, en revérifiant toutes les 15 s.
      showWhenFree() {
        const cart = document.querySelector('cart-drawer');
        const other = document.querySelector('quick-view[open], help-drawer[open], menu-drawer[open]');
        if ((cart && cart.hasAttribute('open')) || other) {
          setTimeout(() => this.showWhenFree(), 15000);
          return;
        }
        this.show();
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        // Maison Textile : une personne inscrite garde son cookie d'un an (posé à l'inscription),
        // on ne le raccourcit pas en fermant la fenêtre.
        if (this.getCookie('mt:newsletter-subscribed')) return;

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );

  /* Maison Textile — inscription depuis le popup : envoi du formulaire client Shopify puis
     ajout de la serviette offerte (variante 58539500405120).

     Révision du 23/09 (copie de V18) — ce qui a changé et pourquoi :
     1. L'adresse est vérifiée avant l'envoi. Le clic contourne la validation du navigateur,
        une adresse mal tapée passait donc et recevait la serviette.
     2. La serviette n'est ajoutée que si l'inscription a réussi. Avant, une erreur ou une page
        de vérification anti-robot de Shopify était ignorée : cadeau donné, e-mail perdu.
        Si Shopify demande sa vérification, le formulaire est envoyé normalement pour que la
        personne puisse la passer ; au retour, la serviette est ajoutée.
     3. Le message dit ce qui s'est vraiment passé. Avant, « serviette ajoutée » s'affichait
        même quand le cookie empêchait l'ajout (ce que Ciprian voyait sur certains téléphones).
     4. On regarde le panier avant d'ajouter : jamais deux serviettes (commande #1504).
     5. Le tiroir panier ne s'ouvre que s'il contient autre chose que la serviette : sinon le
        client voyait un panier à 0 € au milieu de sa visite.
     6. Une fois inscrite, la personne ne revoit plus ni le popup ni le flottant (cookie 1 an).

     Le bloc cadeau du tiroir panier (snippets/mt-cart-gift.liquid) est en veille depuis le
     23/09 ; il partage le cookie concept:newsletter-gift-added avec ce fichier. */
  document.addEventListener('DOMContentLoaded', function () {
    var GIFT_VARIANT = 58539500405120;
    var COOKIE_GIFT = 'concept:newsletter-gift-added';
    var COOKIE_SUBSCRIBED = 'mt:newsletter-subscribed';
    var COOKIE_POPUP = 'concept:newsletter-popup';
    var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

    // 30/10 (Alex) : la newsletter « serviette offerte » doit parler la langue de la page, de A à Z (le site roumain
    // affichait les messages en français). Langue lue sur <html lang>, français par défaut.
    var TXT = {
      fr: {
        email: 'Merci de saisir une adresse e-mail valide.',
        echec: 'L’inscription n’a pas abouti. Réessayez dans un instant.',
        cadeau: 'Vous êtes bien inscrit(e), mais la serviette n’a pas pu être ajoutée. Validez à nouveau pour réessayer.',
        deja: 'Merci ! Votre serviette offerte est déjà dans votre panier.',
        ajoutee: 'Merci ! Votre serviette offerte a été ajoutée à votre panier.',
        attend: 'Merci ! Votre serviette offerte vous attend dans le panier : elle partira avec votre commande.'
      },
      ro: {
        email: 'Introduceți o adresă de e-mail validă.',
        echec: 'Abonarea nu a reușit. Încercați din nou peste câteva clipe.',
        cadeau: 'V-ați abonat, dar prosopul cadou nu a putut fi adăugat. Trimiteți din nou pentru a reîncerca.',
        deja: 'Mulțumim! Prosopul cadou este deja în coșul dumneavoastră.',
        ajoutee: 'Mulțumim! Prosopul cadou a fost adăugat în coșul dumneavoastră.',
        attend: 'Mulțumim! Prosopul cadou vă așteaptă în coș: va pleca împreună cu comanda dumneavoastră.'
      },
      de: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        echec: 'Die Anmeldung hat nicht geklappt. Bitte versuchen Sie es gleich noch einmal.',
        cadeau: 'Sie sind angemeldet, aber das Geschenk-Handtuch konnte nicht hinzugefügt werden. Bitte senden Sie erneut.',
        deja: 'Danke! Ihr Geschenk-Handtuch ist bereits in Ihrem Warenkorb.',
        ajoutee: 'Danke! Ihr Geschenk-Handtuch wurde Ihrem Warenkorb hinzugefügt.',
        attend: 'Danke! Ihr Geschenk-Handtuch wartet im Warenkorb und wird mit Ihrer Bestellung verschickt.'
      }
    };
    var T = TXT[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || TXT.fr;

    if (hasCookie(COOKIE_SUBSCRIBED)) {
      document.documentElement.classList.add('mt-nl-subscribed');
    }

    var forms = document.querySelectorAll('.newsletter-form');

    forms.forEach(function (form) {
      var contextInput = form.querySelector('input[name="contact[context]"]');
      if (!contextInput || contextInput.value !== 'popup') return;

      var submitButton = form.querySelector('button[type="submit"]');
      if (!submitButton) return;

      // Retour de la vérification anti-robot de Shopify : l'inscription est faite, on termine.
      if (/[?&]customer_posted=true/.test(window.location.search) && form.querySelector('.alert')) {
        onSubscribed(form);
      }

      var busy = false;

      submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (busy) return;

        var emailInput = form.querySelector('input[name="contact[email]"]');
        var email = emailInput ? emailInput.value.trim() : '';
        if (!EMAIL_RE.test(email)) {
          showMessage(form, T.email, 'error');
          if (emailInput) emailInput.focus();
          return;
        }

        busy = true;
        submitButton.disabled = true;

        fetch(form.action || window.location.pathname, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            if (res.redirected && /\/challenge/.test(res.url || '')) throw new Error('challenge');
            if (!res.ok) throw new Error('http ' + res.status);
            return onSubscribed(form);
          })
          .catch(function (err) {
            if (err && err.message === 'challenge') {
              form.submit();
              return;
            }
            console.error('Erreur inscription newsletter:', err);
            busy = false;
            submitButton.disabled = false;
            showMessage(form, T.echec, 'error');
          });
      }, true); // phase de capture : s'exécute avant magnet-button
    });

    function onSubscribed(form) {
      return addFreeGift().then(function (result) {
        if (result.state === 'failed') {
          // Pas de cookie « inscrit » ici, et le champ reste visible : la personne peut réessayer.
          showMessage(form, T.cadeau, 'error');
          return;
        }

        setCookie(COOKIE_SUBSCRIBED, 365);
        setCookie(COOKIE_POPUP, 365);
        document.documentElement.classList.add('mt-nl-subscribed');

        var msg;
        if (result.state === 'already') {
          msg = T.deja;
        } else if (result.others) {
          msg = T.ajoutee;
        } else {
          msg = T.attend;
        }
        showMessage(form, msg, 'success');
      });
    }

    function showMessage(form, text, kind) {
      var existingAlert = form.querySelector('.alert');
      if (existingAlert) existingAlert.remove();

      var alert = document.createElement('div');
      alert.className = 'alert alert--' + kind;
      alert.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      alert.textContent = text;
      form.appendChild(alert);

      var field = form.querySelector('.field');
      if (field) field.style.display = kind === 'success' ? 'none' : '';
    }

    // Résout toujours : { state: 'added' | 'already' | 'failed', others: le panier contient-il autre chose }
    function addFreeGift() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var inCart = items.some(function (i) { return String(i.variant_id) === String(GIFT_VARIANT); });
          var others = items.some(function (i) { return String(i.variant_id) !== String(GIFT_VARIANT); });
          if (inCart) return { state: 'already', others: others };

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1 }] })
          }).then(function (res) {
            if (!res.ok) throw new Error('add ' + res.status);
            setCookie(COOKIE_GIFT, 30);
            return { state: 'added', others: others };
          });
        })
        .then(function (result) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: result.others } }));
          return result;
        })
        .catch(function (err) {
          console.error('Erreur ajout cadeau newsletter:', err);
          return { state: 'failed', others: false };
        });
    }

    function hasCookie(name) {
      return document.cookie.indexOf(name + '=') !== -1;
    }

    function setCookie(name, days) {
      document.cookie = name + '=true; max-age=' + (days * 24 * 60 * 60) + '; path=/';
    }
  });
}
